import React from "react"
import { Tile } from "@carrotfertility/carotene-core"
import { CheckInExperienceCta } from "../../carrot-plans/check-in/CheckInExperienceCta"
import useCarrotPlan from "#/components/carrot-plans/hooks/useCarrotPlan"
import useCarrotPlanEmployeeSettings from "#/components/carrot-plans/hooks/useCarrotPlanEmployeeSettings"
import { useGetCarrotPlanRequestStatus } from "#/components/carrot-plans/hooks/useCarrotPlanRequestStatus"
import { useGetInProgressCarrotPlanRequestType } from "#/components/carrot-plans/hooks/useGetInProgressCarrotPlanRequestType"
import { CarrotPlan } from "#/types/carrotPlanTypes"
import { isPlanOlderThan7Days } from "#/components/carrot-plans/shared/calculateIsPlanOlderThan7Days"

function carrotPlanCompleted(carrotPlan: Pick<CarrotPlan, "steps">): boolean {
  return Boolean(carrotPlan?.steps?.every((step) => Boolean(step?.completedAtUtc)))
}

export function CarrotPlansCheckInModule(): JSX.Element {
  const carrotPlanQuery = useCarrotPlan()
  const carrotPlanEmployeeSettingsQuery = useCarrotPlanEmployeeSettings()
  const cpRequestStatusQuery = useGetCarrotPlanRequestStatus()
  const inProgressCarrotPlanRequestType = useGetInProgressCarrotPlanRequestType()

  const isRequestInProgress = inProgressCarrotPlanRequestType.data != null
  const showCheckInModule =
    (carrotPlanQuery.data?.isStale || carrotPlanCompleted(carrotPlanQuery.data)) &&
    !carrotPlanEmployeeSettingsQuery.isDoneForNow &&
    !cpRequestStatusQuery.data?.carrotPlanIsOnTheWay &&
    !isRequestInProgress &&
    carrotPlanQuery.data?.steps?.length > 0

  if (!showCheckInModule || !isPlanOlderThan7Days(carrotPlanQuery.data?.createdAtUtc)) {
    return null
  }

  return (
    <Tile variant="secondary">
      <CheckInExperienceCta variant="button" />
    </Tile>
  )
}
